import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Button } from '../../../../components/buttons'

const wooCard = (props) => {
    return (
        <div className="px-5">
            <div className="row d-flex justify-content-between">
                <img 
                    style={{height:48}} 
                    src={`/images/landing/woocommerce-logo.png`} 
                    alt={`Biteship WooCommerce`}
                />
                {
                    props.token  ? 
                        <div>
                            {
                                props.token.status === 'notActive' ? 
                                    <div className="pr-4 p-1 float-right d-flex">
                                        <div className="pt-2 pr-4">🛑 <b>Kunci Belum Aktif</b></div>
                                        <Button
                                            onClick={() => props.onOpenQR(props.token.id)}
                                            className="btn btn-outline-primary btn-sm mr-2"
                                            loading={props.loadingExtendKey}
                                        >
                                            Aktivasi
                                        </Button>
                                        <button
                                            onClick={() => props.onDeleteToken(props.token.id)}
                                            className="btn btn-outline-primary btn-sm"
                                        >
                                            Putuskan
                                        </button>
                                    </div>
                                    :
                                    <div>
                                        <div className="pr-4 p-1 float-right d-flex align-items-center">
                                            <div className="pr-4">
                                                <div>✅ <b>Kunci Sudah Dibuat</b></div>
                                                {
                                                    props.token.type === 'woocommerceFree' ? null :
                                                    <div>
                                                        {
                                                            moment(props.token.dueAt).isBefore(moment()) ? 
                                                            <div>
                                                                ❗❗ Sudah expired melewati <b>{moment(props.token.dueAt).format("D MMMM YYYY")}</b>
                                                            </div>
                                                            :
                                                            <div>
                                                                Berlaku sampai <b>{moment(props.token.dueAt).format("D MMMM YYYY")}</b>
                                                            </div>
                                                        } 
                                                    </div>
                                                }
                                            </div>
                                            {
                                                    props.token.type === 'woocommerceFree' ? null :
                                                    <Button
                                                        onClick={() => {props.onExtendKey(props.token.id)}}
                                                        className="btn btn-outline-primary btn-sm mr-2"
                                                        loading={props.loadingExtendKey}
                                                    >
                                                        Perpanjang
                                                    </Button>
                                            }              
                                            <button
                                                onClick={() => props.onDeleteToken(props.token.id)}
                                                className="btn btn-outline-primary btn-sm"
                                            >
                                                Putuskan
                                            </button>
                                        </div>
                                    </div>
                            }
                        </div> 
                        :
                        <div className="input-group-sm col-2">
                            <button 
                                onClick={() => props.setModal(true)}
                                type="submit" 
                                class="btn btn-sm btn-primary"
                            >
                                Aktifkan 
                            </button>
                        </div>
                }
                
            </div>
        </div>
    )
}

export default wooCard;